/**
 * Maps Malayalam dish values to English for display.
 * Used for backward compatibility with existing database records.
 */
const MALAYALAM_TO_ENGLISH = {
  'ബിരിയാണി': 'Biriyani',
  'നെയ്‌ച്ചോറ്': 'Neychoru',
  'പത്തിരി': 'Pathiri',
  'സ്നാക്സ്': 'Snacks',
  'മറ്റുള്ളവ': 'Other',
  'ജീരക കഞ്ഞി': 'Jeeraka Kanji ജീരക കഞ്ഞി',
};

/**
 * Returns the English display name for a dish value.
 * Handles both Malayalam (legacy) and English (new) values.
 * @param {string} dish - The stored dish value (Malayalam or English)
 * @returns {string} - The English display name
 */
export function getDishDisplayName(dish) {
  if (!dish) return '';
  return MALAYALAM_TO_ENGLISH[dish] || dish;
}
